<template>
  <div class="QuizInput">
    <form autocomplete="off" spellcheck="false" autocorrect="off" novalidate @submit.prevent="validField">
      <input name="response" @keyup="inspectField" ref="field" class="QuizInput_input" :autofocus="$tools.isTouchDevice() ? null : 'autofocus'" :type="type" :min="settings.min" :max="settings.max" :minlength="settings.minlength" :maxlength="settings.maxlength" v-validate="'required'" v-model="response" required :placeholder="settings.placeholder || settings.min || '00'" :pattern="settings.pattern">

      </input>
    </form>
    <div class="QuizInput_value" v-if="settings.value">{{ settings.value }}</div>
    <transition name="bottom" mode="out-in">
      <div class="QuizInput_error" v-html="errorMessage" v-if="errorMessage"></div>
    </transition>
    
  </div>
</template>

<script>
  import french from "vee-validate/dist/locale/fr";

  export default {
    name: "QuizInput",
    props: [ 'settings', 'type' ],
    data() {
      return {
        response: '',
        errorMessage: null,
        checkTimeout: null
      }
    },
    methods: {
      inspectField()
      {
        if (this.response.length > this.$refs.field.maxLength){
          this.$refs.field.value = this.$refs.field.value.slice(0, this.$refs.field.maxLength)
          this.response = this.$refs.field.value
        }

        if(this.checkTimeout)
          clearTimeout(this.checkTimeout)

        this.$validator.validate().then((result) =>
        {
          console.log('result', result)
          if(result){
            this.$emit('fieldOk', this.response)
            this.errorMessage = null
          }
          else{
            this.$emit('fieldOk', null)
            this.checkTimeout = setTimeout( () => {
              if(this.settings.minlength && this.$refs.field.value.length >= this.settings.minlength && this.$refs.field.value.length >= 1)
                this.errorMessage = this.settings.error || 'Réponse invalide.'
              else if(!this.settings.minlength && this.$refs.field.value.length >= 1)
                this.errorMessage = this.settings.error || 'Réponse invalide.'
              else if(this.$refs.field.value.length < 1)
                this.errorMessage = null
             }, 600)
          }
        })
      },
      validField()
      {
        this.$validator.validate().then((result) =>
        {
          if(result)
          {
            this.$parent.validateQuestion()
          }
        })
      }
    },
    beforeDestroy()
    {
      if(this.checkTimeout)
        clearTimeout(this.checkTimeout)
    },
    created()
    {

      this.$validator.localize("fr", {
        messages: french.messages
      });

      this.$validator.localize("fr");
    }
  }
</script>

<style lang="stylus" scoped>
.QuizInput

  position relative
  margin auto
  display table
  width 100%
  max-width 400px
  min-width 200px

  input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button
    -webkit-appearance: none;
    
 
  input[type="number"]
    -moz-appearance: textfield;

  ::placeholder

    font-family $f-content
    font-size 110px
    line-height 110px
    font-weight normal
    text-align center
    color #c9d9f2!important
    opacity 1

    @media $small

      font-size 90px
      line-height 90px

  &_error

    color $red
    text-align center
    font-size 18px
    font-family $f-title
    font-weight 500
    letter-spacing: -0.3px;
    margin-top 15px

  &_input

    width 100%
    margin: 0;
    font-family $f-content
    font-size 110px
    line-height 110px
    // height 110px
    color $blue
    font-weight normal
    padding 0px
    appearance none
    border 0px
    background-color transparent
    border-radius 0px
    text-align center

    @media $small

      font-size 90px
      line-height 90px

  &_value

    font-family $f-title
    font-weight 500
    font-size: 18px;
    line-height 18px
    color: $blue
    letter-spacing: -0.3px;
    text-align: center;
    position relative
    // top -10px
</style>